export default __webpack_public_path__ + "assets/emoji-thinking1.gif";